import type { AddProjectContentItemInputRequest } from '../types'
import type { ContentItemViewNodesType } from '../types/contentItemViewNode.type'
import { CreateContentItemInputBuilder } from './CreateContentItemInputBuilder'
import { ObjectBuilder } from './ObjectBuilder'

/** Builds the input variables for adding a new Article content item. */
export class ArticleInputBuilder extends CreateContentItemInputBuilder {
    /**
     * Initializes the input builder for an Article.
     * @param text - The initial text (title) for the Article.
     * @param siblingId - The sibling node used for context.
     * @param contentItemViewNodes - The list of all content item view nodes from store.
     */
    constructor(
        text: string,
        siblingId: string,
        contentItemViewNodes?: Partial<ContentItemViewNodesType>[]
    ) {
        super(text, siblingId, contentItemViewNodes)
    }

    /**
     * Builds the input variables for adding a new Article content item.
     * @returns The input object (Partial<AddProjectContentItemInputRequest['input']>).
     */
    buildInput(): Partial<AddProjectContentItemInputRequest['input']> {
        return new ObjectBuilder<AddProjectContentItemInputRequest['input']>(
            this.buildBaseInput()
        )
            .set('contentItemOwnerType', 'ProductTypeProperty')
            .set(
                'contentItemParentId',
                this.contentItem?.dtvContentItemParentId ||
                    this.contentItem?.dtvParentId
            )
            .set('contentItemParentType', 'None')
            .set('textType', this.contentItem?.textType || 'Article')
            .set('subElements', [
                {
                    text: 'Insert your paragraph, or, paste content.',
                },
            ])
            .set('propertyKey', this.text)
            .build()
    }

    /**
     * Builds the complete request object for adding an Article.
     * @returns The variables object (Partial<AddProjectContentItemInputRequest>).
     */
    build(): Partial<AddProjectContentItemInputRequest> {
        return new ObjectBuilder<AddProjectContentItemInputRequest>(
            this.buildBaseRequest()
        )
            .set('input', this.buildInput())
            .set('rootArticleContentItemIds', [])
            .build()
    }
}
